/**
 * Build an <img src=…> value for an R2 key.
 *
 *   { r2_key: '…' } → /api/media/<r2_key>
 *
 * Returns '' for absent or malformed refs (rendering pages still mount).
 */
export function mediaSrc(imageRef) {
    if (!imageRef?.r2_key) return ''
    return `/api/media/${encodeURI(imageRef.r2_key)}`
}
